import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import enTranslation from "./locales/en/translation.json";
import esTranslation from "./locales/es/translation.json";

// Sync HTML lang attribute with i18next language (registered before init to capture initial event)
i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});

// Story 28-4: keep the API client's URL-prefix locale in lockstep with i18n.
// Without this, a guest who toggles ES via LanguageToggle continues to hit
// /v1/en/public/... — backend localized validation messages come back in the
// wrong language, FormAccessLog records the wrong locale. Late-bound via
// dynamic import so this module stays import-cycle-free with services/api/client.
i18n.on('languageChanged', (lng) => {
  void import('@/services/api/client').then(({ apiClient }) => {
    apiClient.updateLanguage(lng);
  });
});

i18n
  // detect user language
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next
  .use(initReactI18next)
  // init i18next
  .init({
    resources: {
      en: {
        translation: enTranslation,
      },
      es: {
        translation: esTranslation,
      },
    },
    // Constrain detected language to what the backend actually supports.
    // Without this, a Portuguese phone produces i18n.language === "pt-BR",
    // which the API client forwards as /v1/pt/... → API Gateway 401 (no
    // matching route), surfaced to the user as a generic "Something went
    // wrong" card with no Sentry event (4xx are not captured).
    supportedLngs: ["en", "es"],
    load: "languageOnly",
    fallbackLng: "en",
    debug: process.env.NODE_ENV === "test",
    // Story 28-4: detection order — read the LanguageToggle's
    // localStorage key BEFORE the URL path / browser locale. Without this,
    // a guest who chose "ES" yesterday on this device would see "EN" again
    // on a fresh visit if the URL or browser detector picks "en" first.
    detection: {
      order: ["localStorage", "path", "navigator", "htmlTag"],
      lookupLocalStorage: "preferredLang",
      caches: ["localStorage"],
    },

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

// Fallback: ensure lang is set if init resolved synchronously before handler
document.documentElement.lang = i18n.language || 'en';

export default i18n;
